/**
 * Utility functions for handling price calculations and conversions
 */

/**
 * Safely convert euros to cents avoiding floating point precision issues
 * @param {number|string} euros - The amount in euros
 * @returns {number} The amount in cents
 */
export const eurosToCents = (euros) => {
  if (!euros) return 0;

  // Convert to string, then to number to avoid floating point precision issues
  const eurosStr = euros.toString();
  const [integer, decimal = ''] = eurosStr.split('.');
  const paddedDecimal = decimal.padEnd(2, '0').slice(0, 2);
  return parseInt(integer + paddedDecimal, 10);
};

/**
 * Convert cents to euros
 * @param {number} cents - The amount in cents
 * @returns {number} The amount in euros
 */
export const centsToEuros = (cents) => {
  return cents / 100;
};

/**
 * Format price for display
 * @param {number} price - The price to format
 * @param {string} currency - The currency symbol (default: '€')
 * @returns {string} Formatted price string
 */
export const formatPrice = (price, currency = '€') => {
  return `${currency}${price.toFixed(2)}`;
};
